export default __webpack_public_path__ + "static/media/flag_PT-PT.16673426.png";